import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FaLock,
  FaUserAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaAt,
} from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

import { Auth } from "services/action";
import { Page, Input } from "ui/components";
import signup from "../../../assets/signup.png";

const SignupScreen = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const { user, ref_code } = location?.state;

  const [refCode, setRefCode] = React.useState("");
  const [avatar, setAvatar] = React.useState("");
  const [socialID, setSocialID] = React.useState("");
  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");

  const $handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      type: "personal",
      name: name,
      phone: phone,
      username: username,
      password: password,
      email: email,
      confirm_password: confirmPassword,
      avatar,
      is_active: true,
      register_app: "driver",
    };

    if (socialID) {
      payload.social_id = socialID;
    }

    if (refCode) {
      payload.referral_code = refCode;
    }

    const req = await Dispatch(Auth.$signup(payload));

    if (req?.message === "success") {
      const data = {
        app: "driver",
        username: username,
        password: password,
      };

      await Dispatch(Auth.$signin(data));
    }
  };

  React.useEffect(() => {
    setRefCode(ref_code);

    if (user) {
      setName(user?.name);
      setEmail(user?.email);
      setSocialID(user?.sub);
      setAvatar(user?.picture);
    }
  }, []);

  return (
    <Page className="bg-container-image position-relative">
      <div className="mt-3 mb-3 d-flex align-items-center justify-content-center">
        <img src={signup} alt="" height={200} />
      </div>

      <div className="mb-5">
        <div style={{ fontSize: 20, fontWeight: 700, textAlign: "left" }}>
          Daftar Akun Sekarang
        </div>

        <div className="mt-2 mb-2" style={{ textAlign: "left" }}>
          Silahkan lengkapi data anda untuk membuat akun
        </div>

        <form onSubmit={$handleSubmit}>
          <div className="form-group">
            <Input
              icon={<FaUserAlt />}
              value={refCode}
              onChange={(e) => setRefCode(e.target.value)}
              type="text"
              placeholder="kode ref"
              error={StateForm?.errors?.ref_code}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaUserAlt />}
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              placeholder="masukkan nama lengkap anda"
              error={StateForm?.errors?.name}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaPhoneAlt />}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="number"
              placeholder="masukkan nomor handphone anda"
              error={StateForm?.errors?.phone}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaEnvelope />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              placeholder="masukkan email anda"
              error={StateForm?.errors?.email}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaAt />}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              type="text"
              placeholder="masukkan username anda"
              error={StateForm?.errors?.username}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaLock />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="masukkan kata sandi anda"
              error={StateForm?.errors?.password}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaLock />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              placeholder="ulangi kata sandi anda"
              error={StateForm?.errors?.confirm_password}
              lg
            />
          </div>
          <Button
            type="submit"
            variant="primary"
            className="w-100 mt-2 p-2 fs-7"
            disabled={StateForm?.loading}
          >
            {!StateForm?.loading ? (
              "Daftar"
            ) : (
              <div className="spinner-border" role="status"></div>
            )}
          </Button>
        </form>

        <div className="page-pretitle text-secondary mt-2 text-center cursor-pointer">
          Sudah punya akun?{" "}
          <span
            className="text-primary"
            onClick={() => History.push("/signin")}
          >
            Login sekarang
          </span>
        </div>
      </div>

      <div
        style={{ textAlign: "center" }}
        className="px-3 position-absolute bottom-0 start-50 translate-middle-x w-100 mb-3"
      >
        <small>
          Dengan masuk dan mendaftar, anda menyetujui{" "}
          <b>syarat &amp; ketentuan </b>
          yang berlaku dan <b>kebijakan privasi</b>.
        </small>
      </div>
    </Page>
  );
};

export default SignupScreen;
